function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#66CEEF;}\n\t.st1{fill:#1A87C7;}\n\t.st2{fill:#BDEDF8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M772.44,382.87c0,154-108.6,342-242,419c-38.6,22.2-76,33.6-109.8,33.6c-6.4,0-12.6-0.4-18.8-1.2 c1.4,0.6,2.8,1,4.4,1.6c3.2,1,6.2,1.8,9.6,2.6c2,0.4,4,1,6.2,1.4c5.2,1,10.8,1.6,16.2,1.8c1.4,0,2.8,0,4.2,0c5,0,10.2,0,15.4-0.6 c1.2-0.2,2.4-0.2,3.6-0.2c6.4-0.6,12.8-1.8,19.4-3.2c1.4-0.4,2.8-0.8,4.4-1.2c4.6-1.2,9.4-2.6,14-4c3.8-1.2,7.8-2.6,11.6-4.2 c4.6-1.8,9.4-3.6,14-5.8c1.6-0.8,3.2-1.6,4.8-2.2c6.8-3.2,13.6-6.8,20.6-10.8c31.2-18,61.6-42.6,90.2-72.6c0.4-0.4,0.8-0.8,1.4-1.4 c5.4-5.6,10.4-11.6,15.6-17.6c2.2-2.6,4.6-5,6.6-7.8c0.6-0.8,1.2-1.6,1.8-2.4c43.2-53.2,77-115.2,97.6-174 c2.2-6.4,4.4-12.8,6.4-19.4c0.8-2.4,1.4-4.6,2-7c1.8-6.6,3.6-13,5-19.4c1.4-6,2.8-12.2,4-18.4c0.6-2.8,1.2-5.6,1.6-8.4 c1-5.6,1.8-11.2,2.6-16.8c0.2-1,0.2-2,0.4-3c1.2-9.4,2-18.8,2.6-28.2c0.2-4.2,0.4-8.6,0.6-12.8c0-3,0-6,0-8.8 c-0.4-34.4-6.2-64.8-17.6-89.8c-8.6-18.8-20-34.2-33.8-46c-0.8-0.6-1.6-1.2-2.4-1.8C759.04,285.27,772.44,329.07,772.44,382.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M770.64,511.47c0.4-1.4,0.6-2.6,1-4c-0.6,2.4-1.4,4.8-2,7C770.24,513.67,770.44,512.47,770.64,511.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M781.04,469.67c-1.2,6.2-2.6,12.4-4,18.4C778.44,482.07,779.84,475.87,781.04,469.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M788.84,395.87c0-1.4-0.2-2.6-0.2-4c0,3,0,6,0,8.8C788.64,399.47,788.84,397.67,788.84,395.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M785.24,444.67c-0.8,5.6-1.6,11.2-2.6,16.8C783.64,455.87,784.24,450.27,785.24,444.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M788.04,413.47c-0.6,9.4-1.4,18.8-2.6,28.2C786.64,432.27,787.64,422.87,788.04,413.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M663.84,710.27c-2.2,2.6-4.4,5.2-6.6,7.8C659.24,715.47,661.64,712.87,663.84,710.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M459.84,841.27c0.4,0,0.8-0.2,1.4-0.2c-1.2,0.2-2.4,0.2-3.6,0.2C458.64,841.27,459.24,841.27,459.84,841.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M529.24,820.27c-1.6,0.8-3.2,1.6-4.8,2.2C526.24,822.07,527.64,821.27,529.24,820.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M737.24,256.07c-0.8-0.8-1.8-1.4-2.6-2l0.2,0.2C735.44,254.87,736.44,255.47,737.24,256.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M510.44,828.47c-3.8,1.4-7.6,2.8-11.6,4.2C502.84,831.27,506.64,829.87,510.44,828.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M484.84,836.47c-1.4,0.4-2.8,0.8-4.4,1.2C482.24,837.47,483.64,837.07,484.84,836.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M400.64,833.67c1.8,0.6,3.6,1.2,5.4,1.8c-1.4-0.4-2.8-1-4.4-1.6C401.24,833.87,401.04,833.87,400.64,833.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M421.64,839.87c-2-0.4-4.2-1-6.2-1.4C417.84,838.67,419.84,839.47,421.64,839.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M718.84,631.27c18.2-31.8,33.2-64.4,44.6-97.4c-20.6,58.8-54.6,121-97.6,174 C685.24,684.27,702.84,658.67,718.84,631.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M442.44,841.47c-1.4,0-2.8,0-4.2,0C439.64,841.47,441.04,841.47,442.44,841.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M641.24,736.27c0.2-0.2,0.2-0.4,0.4-0.4c-0.4,0.4-0.8,0.8-1.4,1.4C640.44,736.67,641.04,736.27,641.24,736.27z "
}), React.createElement("path", {
  className: "st1",
  d: "M766.24,382.87c0,152.4-107,337.6-238.8,413.6c-56,32.4-107.6,39.6-148.2,25.8c2,1.4,3.8,2.8,5.8,4l0.4,0.2 c0.6,0.4,1.4,0.6,2,1c3.8,2.2,7.8,4,12,5.6c0.8,0.4,1.8,0.6,2.8,1c6.2,0.8,12.4,1.2,18.8,1.2c33.8,0,71.2-11.2,109.8-33.6 c133.4-77,242-265,242-419c0-53.6-13.2-97.6-37.4-128.4c-1-0.8-2-1.4-3-2.2c-3.2-2.4-6.4-4.8-9.8-6.8l-2.4-1.4 c-1.8-1-3.8-1.8-5.6-2.8C746.44,269.67,766.24,317.87,766.24,382.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M721.24,244.67c-0.4-0.2-1-0.4-1.4-0.6l2.4,1.4C721.64,245.27,721.44,244.87,721.24,244.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M399.24,833.27c0.6,0.2,1,0.6,1.6,0.8c0.4,0,0.8,0.2,1,0.2C401.04,833.67,399.84,833.47,399.24,833.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M384.84,826.27c0.2,0,0.2,0.2,0.4,0.2c0.6,0.4,1.4,0.6,2,1c-0.6-0.4-1.4-0.6-2-1L384.84,826.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M734.84,254.27l-0.2-0.2c-0.8-0.6-1.8-1.2-2.8-1.8C732.84,252.87,733.84,253.47,734.84,254.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M527.44,796.47c131.8-76.2,238.8-261.4,238.8-413.6c0-64.8-19.6-113.2-52-141.4c-7-3.4-14.2-6.2-21.8-8.2 c0.2,0.2,0.6,0.2,0.8,0.4c43.2,24.8,66.8,77.8,66.8,149.2c0,150.2-105.8,333.4-235.8,408.4c-61.6,35.6-119.2,41.6-162.4,17 c5.2,5.4,11,10,17,14.2C419.84,836.27,471.04,828.67,527.44,796.47z"
}), React.createElement("path", {
  className: "st0",
  d: "M671.84,128.87c-66-35.4-144-6.8-197.8,23.4c-120.2,71.2-223.6,210-269.4,362.2 c-32.4,107.4-39.8,256,46.6,321.2c7.4,5.6,26,16.6,44.8,27.4c-1.6-2-2.8-4.2-4.2-6.2c-2.2-3-4.4-6.2-6.4-9.4 c-2.8-4.6-5.2-9.4-7.8-14.4c-1.4-2.6-2.8-5.2-4-8c-2.6-5.6-4.6-11.6-6.8-17.8c-1-2.6-2-5-2.8-7.8c-2.6-8.6-4.8-17.4-6.6-26.8l0,0 c-0.8-3.8-1.2-8-1.8-12.2c-1-6.6-2.2-13.4-2.8-20.2c0-0.8,0-1.6-0.2-2.2c-2-21.8-1.8-44.2,0-66.8c0-0.4,0-0.6,0-1 c0.8-10.8,2.2-21.6,3.8-32.4c0.4-2.8,0.8-5.4,1.4-8.2c1.4-7.8,2.8-15.4,4.4-23.2c1.2-5.8,2.6-11.6,4-17.4c0.8-3.6,1.8-7,2.8-10.4 c14.6-55.6,38-112.4,69.6-167.2c12.2-21,25.2-41,39-60c0-0.2,0.2-0.2,0.2-0.4c4.4-6.2,9-12.4,13.6-18.4c3.8-5,7.6-9.6,11.4-14.4 c3-3.8,6-7.6,9-11.2c0.6-0.8,1.2-1.6,1.8-2.2c5.6-6.6,11.4-13,17.6-19.6c3.2-3.4,6.4-6.8,9.8-10.2c3.4-3.6,7-7,10.6-10.4 c7.8-7.6,15.6-14.8,23.6-21.8c0.8-0.6,1.4-1.2,2.2-1.8c16.6-14.4,33.8-27.4,51.2-39c3.4-2.2,6.8-4.4,10.2-6.4 c3.8-2.4,7.6-5,11.4-7.2c2.4-1.4,4.6-2.4,6.8-3.6c6.2-3.4,12.4-6.6,18.6-9.8c2.6-1.2,5-2.4,7.6-3.6c8.6-4,17.4-7.6,26.2-10.6 c0.4-0.2,0.8-0.2,1.2-0.4c8.2-2.8,16.6-5.2,24.8-7.2c2-0.4,3.8-1,5.8-1.4c7-1.4,14-2.6,21-3.4c1.8-0.2,3.4-0.6,5.2-0.6 c7.2-0.6,14.4-0.8,21.6-0.6c4.8,0.2,9.4,0.6,14.2,1c1.4,0.2,3,0.2,4.4,0.4L671.84,128.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M243.64,845.47c12,9,47.8,29.4,74,44.2c7.4,4.2,13.8,7.8,18.2,10.4c0.4,0.2,0.8,0.2,1,0.2 c-10.2-6.4-19.6-14-28-22.6c-23.6-13.4-51.6-29.4-61.6-37c-94.2-71-78.8-229.2-48.8-328c43.2-143,142.4-288.8,272.4-365.6 c60.2-33.8,138.6-58.6,204-23.6l51.2,29.6c12,3,23.6,7.4,34.4,13.2c-0.2-0.2-0.2-0.4-0.4-0.6l-82.2-47.4 c-71.2-38.2-153.4-8.2-209.8,23.6l0,0c-122.8,72.6-228.2,214.2-275.2,369.2C157.44,627.47,152.44,776.47,243.64,845.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M411.84,307.67c6.4-7.4,12.8-14.6,19.4-21.8c-6,6.4-12,13-17.6,19.6 C413.04,305.87,412.44,306.67,411.84,307.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M291.64,856.67c1.4,2,2.8,4.4,4.2,6.2c-18.8-10.8-37.4-21.8-44.8-27.4c-86.4-65.2-79.2-213.8-46.6-321.2 c46-152.2,149.2-291,269.4-362.2c53.8-30.2,131.8-58.8,197.8-23.4l35.6,20.6c-1.4-0.2-3-0.2-4.4-0.4c7.8,0.8,15.6,2.2,23,4 l-51.2-29.6c-65.4-35-143.8-10.4-204,23.6c-129.8,76.8-229.2,222.8-272.4,365.6c-29.8,98.8-45.2,257,48.8,328 c10,7.4,38,23.6,61.6,37C302.84,871.27,296.84,864.27,291.64,856.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M277.84,832.87c2.4,5,5,9.8,7.8,14.4C282.84,842.67,280.04,837.87,277.84,832.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.84,807.47c2,6.2,4.2,12.2,6.8,17.8C271.04,819.67,269.24,813.47,266.84,807.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M662.24,149.07c-7,0.8-14,2-21,3.4C648.44,151.07,655.24,149.87,662.24,149.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M252.84,738.47c-0.8-10.4-1.4-21-1.4-32c0-11.4,0.4-23,1.4-34.8C251.04,693.87,250.64,716.27,252.84,738.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M667.44,148.47c7.4-0.6,14.4-0.8,21.6-0.6C681.64,147.87,674.44,147.87,667.44,148.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M402.84,318.87c-3.8,4.6-7.6,9.4-11.4,14.4C395.44,328.27,399.24,323.47,402.84,318.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M635.24,154.07c-8.4,2-16.6,4.2-24.8,7.2C618.84,158.27,627.24,155.87,635.24,154.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M264.24,799.67c-2.6-8.6-4.8-17.6-6.8-26.8l0,0C259.24,782.27,261.64,791.27,264.24,799.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M441.04,275.87c3.4-3.6,7-7,10.6-10.4C447.84,268.87,444.44,272.27,441.04,275.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.24,578.87c-1,3.6-1.8,7-2.8,10.4C267.44,586.07,268.44,582.47,269.24,578.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M262.44,606.67c-1.6,7.8-3.2,15.4-4.4,23.2C259.24,622.47,261.04,614.67,262.44,606.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M377.84,351.47c0,0.2-0.2,0.2-0.2,0.4C377.84,351.67,377.84,351.47,377.84,351.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M256.64,638.27c-1.6,10.8-3,21.6-3.8,32.4C253.64,659.87,255.04,648.87,256.64,638.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M252.84,740.47c0.6,6.8,1.8,13.4,2.8,20.2C254.84,753.87,253.64,747.47,252.84,740.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M477.44,241.47c-0.8,0.6-1.4,1.2-2.2,1.8C475.64,242.87,476.64,242.27,477.44,241.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M575.44,175.47c-6.2,3-12.4,6.2-18.6,9.8C563.04,182.07,569.24,178.47,575.44,175.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M609.24,161.47c-8.8,3-17.6,6.6-26.2,10.6C591.84,168.27,600.64,164.27,609.24,161.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.84,196.07c-3.4,2.2-6.8,4.2-10.2,6.4C531.84,200.27,535.24,198.47,538.84,196.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M550.04,871.47c78-45,151.4-122.6,206.8-218.4c55.2-95.8,85.8-198.2,85.8-288.2c0-88.8-29.6-155-83.6-186 c-3.8-2.2-7.8-3.6-11.6-5.4c-4.4-2-9-4-13.6-5.6c-1-0.4-2-0.6-3-0.8c-6.2-2-12.6-3.6-18.8-4.6c-1.2-0.2-2.4-0.2-3.6-0.4 c-6-1-12-1.6-18.2-1.8c-24.2-0.8-50.2,3.6-77.2,13c-0.2,0-0.4,0.2-0.6,0.2c-8.8,3-17.6,6.8-26.6,10.8c-0.6,0.2-1,0.4-1.6,0.8 c-9,4.2-18.2,9-27.6,14.4c-1.6,1-3.2,2-5,3c-6.2,3.8-12.4,7.6-18.6,11.8c-5.4,3.6-10.6,7.4-15.8,11.2c-1.8,1.4-3.6,2.8-5.4,4.2 c-18.2,13.8-35.6,29-51.8,44.8c-2.2,2.2-4.2,4.2-6.4,6.4c-4.4,4.6-9,9-13.2,13.6c-6.2,6.8-12.4,13.6-18.4,20.8 c-3.6,4.2-7,8.4-10.4,12.8c-3.2,4-6.4,8.2-9.6,12.4c-4.6,6-9.2,12-13.6,18.4c0,0.2-0.2,0.2-0.2,0.4 c-44.2,62.2-83.4,139.6-105.6,219c-1.6,5.6-3,11.2-4.4,16.6c-1,4-1.8,7.8-2.6,11.8c-2.2,9.8-4,19.4-5.6,29 c-0.2,0.8-0.2,1.4-0.4,2.2c-3.6,23.4-5.6,46.6-5.6,68.8c0,19,1.6,36.6,4.2,53.4c0.6,3.2,0.8,6.6,1.4,9.8c1.6,8.4,3.6,16.2,5.8,24 c0.6,2.2,1.4,4.2,2,6.4c2,6,4.2,12,6.6,17.6c0.8,1.6,1.4,3.4,2.2,5c3.2,6.8,6.6,13.2,10.2,19.2c1.2,2,2.6,3.8,3.8,5.6 c2.6,3.8,5.2,7.2,8,10.8c2.2,2.8,4.6,5.4,7,8c2,2.2,4.2,4.2,6.2,6.2c3.8,3.6,7.8,7,12,10.2c4.6,3.4,9,6.8,14,9.8 C401.04,923.47,473.04,916.07,550.04,871.47z M292.44,787.27c-2.8-1.8-3.8-5.6-2-8.4c1.8-2.8,5.4-3.8,8.4-2.2l5.4,3.2 c5,2.8,10.2,5.2,15.4,7.2c-24.2-30.8-37.4-74.6-37.4-128.4c0-154,108.6-342,242-419c46-26.6,90-37,128.4-32 c-4.2-3.4-8.4-7-13.2-9.8l-4.8-2.8c-2.8-1.6-4-5.4-2.4-8.4c1.6-3,5.4-4,8.4-2.4l4.4,2.4l82.2,47.4c0.2,0.2,0.4,0.4,0.8,0.6l3.4,2 c3.2,2,6,4.4,8.8,6.6c1.6,1.2,3.2,2.2,4.6,3.4c34.2,28.4,50.4,72,54.8,119.8c0.2,2.8,0.4,5.6,0.6,8.4c0.2,4.6,0.6,9.2,0.6,13.8 c0,2.6,0.4,4.8,0.4,7.4c0,2.2-0.2,4.4-0.2,6.6c0,1.4-0.2,3-0.2,4.4c-0.6,18.4-2.6,37.4-6,57c-0.2,1.6-0.6,3-0.8,4.6 c-1.6,8-3.2,16-5.2,24c-1.6,6.2-3,12.4-4.8,18.4c-0.4,1.4-0.8,3-1.2,4.4c-0.4,1-0.8,2.2-1,3.2c-0.4,1.6-0.8,3-1.4,4.6 c-1.4,4.8-3.2,9.6-5,14.4c-11.8,34-27,67.6-45.8,100c-20.8,36.2-45,69.2-71.6,98.4c-1.6,1.8-3.2,3.8-5,5.6c-1,1-1.8,2-2.8,3 c-2.2,2.2-4.4,4.2-6.6,6.4c-4.6,4.8-9.4,9.4-14.2,14c-1.6,1.6-3.2,3-5,4.6c-6.4,5.8-12.8,11.4-19.4,16.8c-0.6,0.4-1.2,0.8-1.6,1.4 c-15,12-30.6,22.8-46.6,32c-0.2,0.2-0.4,0.2-0.6,0.4c-0.2,0-0.4,0.2-0.4,0.2c-6.6,3.8-13.4,7.2-20,10.4c-2.4,1.2-4.6,2.2-7,3.2 c-4.6,2-9.2,3.8-13.8,5.6c-4,1.6-8.2,3-12.2,4.4c-1.4,0.4-2.8,1.2-4.4,1.6c-1.8,0.6-3.6,0.8-5.4,1.2c-5.4,1.4-10.6,2.8-15.8,3.6 c-3.6,0.6-7.2,1.4-10.8,1.8c-1.6,0.2-3.4,0.6-5,0.8c-4.8,0.6-9.4,0.6-14,0.8c-0.6,0-1.4,0.2-2,0.2c-6,0-12-0.4-17.8-1 c-17.6-2-33.8-7.4-48.4-15.8l-82.2-47.4c0,0,0-0.2-0.2-0.2L292.44,787.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M801.04,402.67c0,1.4-0.2,3-0.2,4.4C800.64,405.27,800.64,404.07,801.04,402.67z"
}), React.createElement("path", {
  className: "st2",
  d: "M780.24,522.87c0.4-1.4,0.8-3,1.4-4.6c-2,6.4-4,12.6-6.2,19C776.84,532.47,778.84,527.67,780.24,522.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M657.64,736.07c-1.6,1.8-3.2,3.8-5,5.6C654.44,739.87,656.24,737.67,657.64,736.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M788.64,492.27c-1.4,6-3,12.2-4.8,18.4C785.44,504.67,787.24,498.47,788.64,492.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M731.44,236.47l-3.4-2c4.4,2.6,8.4,5.6,12.4,8.6C737.44,240.87,734.44,238.47,731.44,236.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M800.24,374.67c0.4,4.6,0.4,9.2,0.6,13.8C800.64,384.07,800.44,379.47,800.24,374.67z"
}), React.createElement("path", {
  className: "st2",
  d: "M643.64,751.27c-4.6,4.8-9.4,9.6-14.2,14C634.04,760.47,638.84,755.87,643.64,751.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M794.44,463.87c-0.2,1.6-0.6,3-0.8,4.6C793.84,466.67,794.24,465.27,794.44,463.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M319.84,787.07c-5.2-2-10.4-4.4-15.4-7.2l17.6,10.2C321.04,788.87,320.44,787.87,319.84,787.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M528.64,834.27c-4.6,2-9.2,3.8-13.8,5.6C519.64,838.27,524.04,836.27,528.64,834.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M379.04,837.27l-82.4-47.6c0,0,0,0.2,0.2,0.2L379.04,837.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M476.84,850.87c-3.6,0.6-7.2,1.4-10.8,1.8C469.84,852.07,473.44,851.27,476.84,850.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M498.44,845.87c1.4-0.4,2.8-1,4.4-1.6c-3.2,1-6.4,2-9.8,2.8C494.84,846.47,496.64,846.27,498.44,845.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M555.64,820.47c-6.8,3.8-13.4,7.2-20,10.4C542.44,827.67,548.84,824.27,555.64,820.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M782.44,297.27c9.2,20.2,14.8,43.4,17.4,69c-4.4-47.8-20.6-91.2-54.8-119.8 C760.24,259.67,772.84,276.47,782.44,297.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M427.44,853.27c5.8,0.8,11.8,1,17.8,1c0.6,0,1.4-0.2,2-0.2c-0.8,0-1.4,0.2-2.2,0.2 C439.04,854.07,433.04,853.67,427.44,853.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M603.44,787.67c-15.2,12.2-30.8,23-46.6,32C572.64,810.47,588.44,800.07,603.44,787.67z"
}), React.createElement("path", {
  className: "st2",
  d: "M624.44,769.67c-6.4,5.8-12.8,11.6-19.4,16.8C611.44,781.27,618.04,775.47,624.44,769.67z"
}), React.createElement("path", {
  className: "st2",
  d: "M639.64,197.87c4.8,2.8,9,6.4,13.2,9.8c1.6,0.2,3.4,0.4,5,0.6L639.64,197.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M323.64,556.27c12.4-41.4,30.2-82.6,53.2-122.4s49.6-75.8,79.4-107.2c29.8-31.4,61.4-56.8,94-75.6 c31-17.8,61-28.4,89.8-32.2c-2,0-3.8-0.4-5.8-0.4c-31.6,0-67,10.6-103.6,31.8c-130,75-235.8,258.2-235.8,408.4 c0,45.4,9.6,83.2,27.8,111.2c-11.4-26.8-17.4-58.6-17.4-94.6C304.84,637.67,311.24,597.47,323.64,556.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M288.44,658.67c0-152.4,107-337.6,238.8-413.6c49.8-28.8,96-37.8,134.2-29.8c-2.8-2.8-5.8-5-9-7.6 c-38.6-5.2-82.6,5.4-128.4,32c-133.4,77-242,265-242,419c0,53.6,13.2,97.4,37.4,128.4c3.4,1.2,6.8,2,10.2,3 C303.64,760.87,288.44,716.27,288.44,658.67z"
}), React.createElement("path", {
  className: "st2",
  d: "M661.44,215.27c2.8,0.6,5.2,1.6,8,2.2c1,0,2.2,0.2,3.2,0.4c-0.6-0.6-1.2-1.2-1.8-1.8l-13.4-7.6 c-1.6-0.2-3.4-0.4-5-0.6C655.64,210.27,658.84,212.27,661.44,215.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M336.04,797.87c0.6,0.2,1.4,0.2,2,0.4c-0.6-1-1.4-1.8-2-2.8c-2-2-4-3.6-6-5.8c-3.4-1-6.8-1.8-10.2-3 c0.8,1,1.4,2,2.2,3L336.04,797.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M337.84,798.47c-0.6-0.2-1.4-0.2-2-0.4l3,1.6C338.64,799.47,338.04,798.87,337.84,798.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M671.04,215.87c0.6,0.6,1.2,1.2,1.8,1.8c0.6,0,1.2,0.2,2,0.2L671.04,215.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M324.04,774.07c-0.6-1.4-1-2.8-1.6-4.2c-18-28-27.8-65.8-27.8-111.2c0-150.2,105.8-333.4,235.8-408.4 c36.6-21.2,72-31.8,103.6-31.8c2,0,4,0.2,5.8,0.4c1.8-0.2,3.6-0.6,5.2-0.8c6.4-1,12.4-1,18.4-0.8c-0.6-0.6-1.2-1.6-1.8-2.2 c-38.2-8-84.4,1-134.2,29.8c-132,76.2-238.8,261.4-238.8,413.6c0,57.6,15.4,102.2,41.6,131.4c1,0.2,2,0.6,3,0.8 C329.84,785.47,326.64,780.07,324.04,774.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M669.64,217.27c-2.6-0.8-5.2-1.6-8-2.2c0.6,0.6,1.2,1.4,1.8,2.2C665.44,217.27,667.64,217.27,669.64,217.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M329.84,790.07c1.8,2,4,3.8,6,5.8c-1-1.6-2-3.2-3-4.8C331.84,790.47,331.04,790.07,329.84,790.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M269.24,637.47c0.2-0.8,0.2-1.4,0.4-2.2C269.64,636.07,269.24,636.67,269.24,637.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M269.24,769.67c-0.6-3.2-1-6.6-1.4-9.8C268.64,762.87,268.64,766.27,269.24,769.67z"
}), React.createElement("path", {
  className: "st2",
  d: "M349.24,417.87c-30.2,52.4-52.8,106.6-67.2,159.8c22-79.4,61.4-156.8,105.6-219 C374.24,377.87,361.24,397.27,349.24,417.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M275.04,606.27c0.8-4,1.8-7.8,2.6-11.8C276.84,598.47,276.04,602.47,275.04,606.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M277.44,799.87c-0.6-2.2-1.4-4.2-2-6.4C276.04,795.47,276.64,797.67,277.44,799.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M387.84,358.47c4.4-6.4,9-12.4,13.6-18.4C397.24,346.07,392.44,352.27,387.84,358.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M333.44,882.47c-4.2-3.2-8.2-6.6-12-10.2C325.04,876.07,329.24,879.47,333.44,882.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M314.84,866.27c-2.4-2.6-4.6-5.2-7-8C310.44,861.07,312.84,863.67,314.84,866.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M300.04,847.47c-1.2-1.8-2.6-3.6-3.8-5.6C297.44,843.67,299.04,845.47,300.04,847.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M286.04,822.47c-0.8-1.6-1.4-3.4-2.2-5C284.84,819.07,285.44,821.07,286.04,822.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M690.24,160.27c6,0.2,12.2,1,18.2,1.8C702.44,161.07,696.44,160.27,690.24,160.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M411.24,327.87c3.4-4.4,7-8.6,10.4-12.8C418.44,319.07,414.84,323.47,411.24,327.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M612.44,173.47c0.2,0,0.4-0.2,0.6-0.2C612.64,173.47,612.64,173.47,612.44,173.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M733.84,167.87c4.6,1.6,9,3.6,13.6,5.6C742.84,171.47,738.44,169.67,733.84,167.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M584.04,184.87c0.6-0.2,1-0.4,1.6-0.8C585.24,184.67,584.84,184.67,584.04,184.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M711.84,162.27c6.4,1.2,12.6,2.8,18.8,4.6C724.84,165.27,718.44,163.47,711.84,162.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M517.44,225.27c5.2-3.8,10.4-7.6,15.8-11.2C527.64,217.87,522.64,221.47,517.44,225.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M440.44,294.27c4.2-4.6,8.8-9.2,13.2-13.6C449.24,285.27,444.84,289.67,440.44,294.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M459.84,274.27c16.2-15.8,33.6-31,51.8-44.8C494.24,242.87,476.64,257.87,459.84,274.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M556.24,199.67c-1.4,0.8-3,2-4.4,2.8c1.6-1,3.2-2,5-3C556.44,199.67,556.44,199.67,556.24,199.67z"
}), React.createElement("path", {
  className: "st2",
  d: "M294.44,781.27c1.6-3,5.4-4,8.4-2.4c0.4,0.2,0.8,0.4,1.4,0.6l-5.4-3.2c-2.8-1.6-6.6-0.6-8.4,2.2 c-1.8,2.8-0.8,6.6,2,8.4l4.2,2.4C294.04,787.87,292.84,784.27,294.44,781.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M354.24,817.67c-5.6-3.2-10.8-7-15.8-11l-38.4-22.2l-2-1.4l-2-1.4l5.4,3c8.4,4.6,17,7.8,25.6,10.4 c-1.6-1.8-3.2-3.6-4.8-5.4l-17.6-10.2c-0.4-0.2-0.8-0.4-1.4-0.6c-2.8-1.6-6.8-0.6-8.4,2.4c-1.6,2.8-0.6,6.4,2,8.2l82.4,47.6 C369.84,832.07,361.64,825.07,354.24,817.67z"
}), React.createElement("path", {
  className: "st2",
  d: "M326.64,795.27c-8.6-2.6-17.2-5.8-25.6-10.4l36.8,21.2C334.04,802.87,330.44,799.07,326.64,795.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M321.84,790.07c1.6,1.8,3.2,3.8,4.8,5.4c3,0.8,6,2,9.2,2.6L321.84,790.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M338.44,806.47c5,4.2,10.2,7.8,15.8,11c-1.6-1.6-3.4-3-4.8-4.8L338.44,806.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M349.04,812.47c-3.6-4-6.8-8.4-10-13l-3-1.6c-3-0.6-6.2-1.8-9.2-2.6c3.6,3.8,7.2,7.6,11.2,11L349.04,812.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M295.64,782.07l2,1.4l2,1.2c0.4,0.2,0.8,0.4,1.2,0.6L295.64,782.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M301.04,785.07c-0.4-0.2-0.8-0.4-1.2-0.6l38.4,22.2c-0.2,0-0.2-0.2-0.4-0.2L301.04,785.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M349.04,812.47l-11-6.4c0.2,0,0.2,0.2,0.4,0.2l11,6.4C349.24,812.67,349.04,812.67,349.04,812.47z"
}), React.createElement("path", {
  className: "st2",
  d: "M636.64,188.87c1.8-3,5.6-4,8.4-2.2l81.2,47c0.2,0.2,0.6,0.2,0.8,0.4l-82.2-47.4l-4.4-2.4 c-3-1.6-6.6-0.6-8.4,2.4c-1.6,3-0.6,6.6,2.4,8.4l4.8,2.8c-0.2-0.2-0.4-0.4-0.6-0.4C636.04,195.47,635.04,191.67,636.64,188.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M665.24,209.67c-6.6-6.4-13.8-12-22-17l-5.6-3.2l2.2,1.2l2.2,1.2l38.2,22.2c6,2.2,12,5,17.6,8.2 c10,2.8,19.6,6.4,28.4,11.4l-81.2-47c-2.8-1.8-6.6-0.8-8.4,2.2c-1.6,3-0.8,6.6,2.2,8.4c0.2,0.2,0.4,0.4,0.6,0.4l18.2,10.4 C660.24,208.87,662.64,209.07,665.24,209.67z"
}), React.createElement("path", {
  className: "st2",
  d: "M643.44,192.87c8.2,5,15.4,10.6,22,17c5,1.2,9.8,2.4,14.6,4.2L643.44,192.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M697.84,222.27c-5.6-3.2-11.6-6-17.6-8.2l11,6.4C693.64,220.87,695.64,221.47,697.84,222.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M657.64,208.27l13.4,7.6c-1.8-2-3.6-4.2-5.6-6C662.64,209.07,660.24,208.87,657.64,208.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M691.04,220.27l-11-6.4c-4.8-1.8-9.6-3-14.6-4.2c2,2,3.8,4,5.6,6l3.6,2 C680.24,218.47,685.44,219.07,691.04,220.27z"
}), React.createElement("path", {
  className: "st2",
  d: "M680.24,214.07l-38-22L680.24,214.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M640.04,190.87l-2.2-1.2l5.6,3.2c-0.4-0.2-0.8-0.6-1.4-1L640.04,190.87z"
}), React.createElement("path", {
  className: "st2",
  d: "M680.24,214.07l-38.2-22c0.4,0.2,0.8,0.6,1.4,1L680.24,214.07C680.04,214.07,680.24,214.07,680.24,214.07z"
}), React.createElement("path", {
  className: "st2",
  d: "M691.04,220.27L691.04,220.27l-10.8-6.4h-0.2L691.04,220.27z"
}), React.createElement("polygon", {
  className: "st2",
  points: "680.24,214.07 680.04,214.07 691.04,220.27 691.04,220.27  "
}), React.createElement("path", {
  className: "st1",
  d: "M762.64,173.87C762.64,173.87,762.44,173.87,762.64,173.87c53.2,31,86.2,97.2,86.2,191.2 c0,94.2-33.2,198.6-86.6,291.4c-53.4,92.6-127.4,173.4-209,220.6c-81.4,47-155.4,51.6-208.8,20.8c0,0,0,0,0,0.2 c-1.2,1.8-3.2,3-5.2,3c-0.6,0-1.4-0.4-2-0.6c1.4,0.8,2.6,2,3.8,2.6c23.8,13.8,50.8,20.6,80.2,20.6c41.6,0,87.6-13.8,135-41.4 c79.8-46.2,154.8-125.2,211.2-222.8s87.4-202.2,87.4-294.4c0-93.4-31.8-163.4-89.6-196.8c-1.4-0.8-3.2-1.4-4.6-2.2 C762.84,167.87,763.84,171.07,762.64,173.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M657.24,718.27c-5.2,6-10.2,11.8-15.6,17.6C646.84,730.07,652.24,723.87,657.24,718.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M524.44,822.47c-4.8,2.2-9.4,4-14,5.8C515.24,826.47,520.04,824.87,524.44,822.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M415.44,838.47c-3.2-0.8-6.4-1.6-9.6-2.6C409.24,836.47,412.44,837.47,415.44,838.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M494.84,833.87c1.4-0.4,2.8-1,4.2-1.6c-4.8,1.6-9.4,3-14,4C488.04,835.87,491.64,835.07,494.84,833.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M480.44,837.67c-6.6,1.4-13,2.4-19.4,3.2C467.44,840.07,474.04,839.07,480.44,837.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M438.04,841.47c-5.6-0.2-11-1-16.2-1.8C427.24,840.87,432.44,841.27,438.04,841.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M785.44,441.67c-0.2,1-0.2,2-0.4,3C785.24,443.87,785.24,442.87,785.44,441.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M776.84,488.27c-1.6,6.4-3.2,12.8-5,19.4C773.84,501.07,775.24,494.67,776.84,488.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M771.24,302.27c11.4,25,17.2,55.4,17.6,89.8c-0.4-54.2-14.4-105-51.4-135.8 C751.24,267.87,762.64,283.47,771.24,302.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M457.84,841.27c-5.2,0.4-10.4,0.6-15.4,0.6C447.44,841.67,452.44,841.47,457.84,841.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M788.64,400.87c0,4.2-0.4,8.4-0.6,12.8C788.44,409.47,788.64,405.27,788.64,400.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M782.64,461.47c-0.6,2.8-1,5.6-1.6,8.4C781.44,467.07,781.84,464.07,782.64,461.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M529.24,820.27c40-18.8,77.6-48,110.8-83.4c-28.6,30-59,54.6-90.2,72.6 C543.04,813.67,536.24,817.07,529.24,820.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M665.64,707.87c-0.6,0.8-1.2,1.6-1.8,2.4C664.44,709.67,665.24,708.67,665.64,707.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M768.44,519.47c0.4-1.6,0.8-3.2,1.4-4.6c-2,6.4-4.2,13-6.4,19.4C765.24,529.07,766.84,524.07,768.44,519.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M781.64,493.87c8.4-33.2,13.2-66.2,13.2-97.8c0-12.6-1-24.2-2.4-35.6 C797.64,404.87,791.84,452.87,781.64,493.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M404.24,841.27c-2.2-0.8-4.6-1.4-6.8-2.4C399.64,840.07,401.84,840.47,404.24,841.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M439.64,847.67c-0.2,0-0.4,0-0.6,0C439.24,847.67,439.24,847.67,439.64,847.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M421.04,845.87c-2-0.4-4-0.8-6-1.4C416.84,845.07,419.04,845.27,421.04,845.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M460.44,847.27c0.6,0,1.2-0.2,1.8-0.4c-1.2,0.2-2.6,0.2-3.8,0.4C459.24,847.27,459.84,847.27,460.44,847.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M735.44,247.27c1.8,1.4,3.8,2.6,5.4,4C739.24,249.87,737.44,248.87,735.44,247.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M789.84,340.87c0.4,1.6,0.6,3.2,1,5C790.24,344.07,790.04,342.67,789.84,340.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M511.04,834.87c-3.2,1.2-6.4,2.4-9.8,3.4C504.84,837.27,507.84,836.07,511.04,834.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M724.04,634.27c17.8-30.8,32.8-63.4,44.4-96.2c-20.8,58.4-54.8,121-98.6,174.6 C689.84,688.47,708.04,662.27,724.04,634.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M530.64,826.47c-1.2,0.6-2.2,1.2-3.4,1.6C528.64,827.47,529.84,827.07,530.64,826.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M669.24,713.27c-2.8,3.4-5.8,6.6-8.6,10C663.84,720.07,666.44,716.67,669.24,713.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M776.64,513.47c0.4-1.2,0.6-2.6,1-3.8c-0.6,2.2-1.2,4.4-2,6.6C776.04,515.27,776.44,514.27,776.64,513.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M645.44,740.27c0.4-0.4,0.6-0.6,0.8-1c-0.8,0.8-1.6,1.8-2.6,2.6C644.44,741.27,645.24,741.07,645.44,740.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M726.44,244.87c2.8,3,5.4,6,8,9.2c0.8,0.6,1.8,1.4,2.6,2c37,31,51,81.6,51.4,135.8c0,1.4,0.2,2.6,0.2,4 c0,1.6-0.2,3.2-0.2,5c0,4.2-0.2,8.4-0.6,12.8c-0.4,9.2-1.4,18.6-2.6,28.2c-0.2,1-0.2,2-0.4,3c-0.8,5.6-1.6,11.2-2.6,16.8 c-0.6,2.8-1,5.6-1.6,8.4c-1.2,6-2.4,12.2-4,18.4c-1.6,6.6-3.2,13-5,19.4c-0.4,1.4-0.6,2.6-1,4c-0.2,1-0.6,2-1,3 c-0.4,1.6-0.8,3.2-1.4,4.6c-1.6,4.8-3.4,9.8-5,14.8c-11.4,33-26.2,65.6-44.6,97.4c-16,27.6-33.8,53.2-53,76.8 c-0.6,0.8-1.2,1.6-1.8,2.4c-2.2,2.6-4.4,5.2-6.6,7.8c-5.2,6-10.2,11.8-15.6,17.6c-0.2,0.2-0.2,0.4-0.4,0.4 c-0.2,0.4-0.6,0.6-0.8,0.8c-33.2,35.2-70.8,64.6-110.8,83.4c-1.6,0.8-3.2,1.6-4.8,2.2c-4.6,2-9.4,4-14,5.8 c-3.8,1.4-7.8,2.8-11.6,4.2c-1.4,0.4-2.8,1-4.2,1.6c-3.4,1-6.6,1.8-9.8,2.6c-1.4,0.4-2.8,0.8-4.4,1.2c-6.6,1.4-13,2.4-19.4,3.2 c-0.4,0-0.8,0.2-1.4,0.2c-0.8,0-1.4,0-2.2,0c-5.2,0.4-10.4,0.6-15.4,0.6c-1.4,0-2.8,0-4.2,0c-5.6-0.2-11-0.8-16.2-1.8 c-2-0.4-4.2-1-6.2-1.4c-3.2-0.8-6.4-1.6-9.6-2.6c-1.8-0.6-3.6-1-5.4-1.8c-4.4-0.6-8.6-1.4-12.8-2.4c0,1,0,2-0.4,3 c3.2,1.6,6.6,3.4,10,4.6c2.2,0.8,4.4,1.6,6.8,2.4c3.6,1.2,7.2,2.2,10.8,3c2,0.4,4,1,6,1.4c5.8,1,11.8,1.8,17.8,2c0.2,0,0.4,0,0.6,0 c6.2,0.2,12.6,0,19.2-0.6c1.2-0.2,2.6-0.2,3.8-0.4c12.4-1.4,25.6-4.4,39-8.8c3.2-1,6.4-2.2,9.8-3.4c5.4-2,10.8-4,16.2-6.6 c1.2-0.6,2.2-1,3.4-1.6c7.4-3.4,14.8-7.2,22.2-11.6c32.2-18.6,62.8-43.6,90.8-73c0.8-0.8,1.8-1.8,2.6-2.6c4.8-5.2,9.6-10.6,14.2-16 c2.8-3.4,5.8-6.6,8.6-10c0.2-0.2,0.4-0.4,0.4-0.6c43.6-53.6,77.8-116.2,98.6-174.6c2.6-7.2,5-14.6,7.2-21.8c0.6-2.2,1.4-4.4,2-6.6 c1.6-5.2,2.8-10.4,4.2-15.8c10-40.8,15.8-88.8,10.8-133.4c-0.6-5-1.2-9.8-2-14.6c-0.2-1.6-0.6-3.2-1-5c-3-15-7.4-29-13-41.2 c-9-19.8-21-36-35.6-48.4c-1.8-1.4-3.6-2.8-5.4-4c-2.2-1.6-4.2-3-6.4-4.6C728.44,243.87,727.64,244.27,726.44,244.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M335.04,768.87c-11.8-26-17.8-57.6-17.8-93.8c0-36.4,6-75.2,18-115.6c12-40.6,29.6-80.8,52-119.6 s48.6-74.2,77.6-104.8s59.6-55.2,91.2-73.4c31.2-18,61.6-28.6,90-31.4c5-0.6,10.2-0.8,15-0.8c4.6,0,8.8,0.4,13.2,0.8 c-1.8-2.4-3.8-4.4-5.6-6.6c-7.4-0.6-15.2-0.6-23.2,0.2c-28.4,2.8-59.8,13.4-92.4,32.2c-32.8,19-64,44.6-92.6,74.6 c-29.6,31.2-56.2,67.4-78.4,106c-22.4,38.6-40.4,79.8-52.6,121c-11.8,39.8-18.4,79.6-18.4,117.4s6.6,70.2,18.4,96.2 c3.2,7.4,7,14,11.2,20.4c0.2,0.2,0.6,0.6,0.8,0.8c2.8,0.4,5.6,0.8,8.4,1.2C344.24,786.27,339.24,778.27,335.04,768.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M361.84,808.27c-0.4-0.4-0.8-0.8-1.2-1.2c-0.2,0-0.4,0-0.6,0c0.4,0.2,1,0.8,1.4,1 C361.64,807.87,361.64,807.87,361.84,808.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M692.44,233.27c-0.4-0.2-0.8-0.4-1.4-0.6c0,0.2,0.2,0.4,0.2,0.4C691.44,232.87,691.84,232.87,692.44,233.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M674.24,230.27c3,0.2,5.8,0.8,8.8,1.2c-1-1.4-2.2-2.8-3.2-4.2c-3.4-1.4-6.8-2.4-10.4-3.4c-0.2,0-0.6,0-0.8-0.2 C670.44,225.87,672.64,227.87,674.24,230.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M349.84,793.87c-2.8-0.4-5.6-0.6-8.4-1.2c2.8,2.6,5.6,5,8.6,7.2c1.6,0.2,3.2,0.6,4.8,0.6 C353.04,798.67,351.64,796.27,349.84,793.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M354.84,800.47c-1.6-0.2-3.2-0.4-4.8-0.6c3.2,2.4,6.4,4.8,10,7c0.2,0,0.4,0,0.6,0 C358.64,804.87,356.64,802.67,354.84,800.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M691.04,232.67c-3.6-2-7.2-3.8-11-5.4c1,1.4,2.2,2.8,3.2,4.2c2.6,0.4,5.4,0.8,8,1.6 C691.24,232.87,691.04,232.67,691.04,232.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M725.04,247.27l-2.8-1.6c3.4,2,6.6,4.4,9.8,6.8C729.64,250.47,727.44,248.47,725.04,247.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M399.24,833.27c-4-1.6-8.2-3.4-12-5.6C391.04,829.67,394.84,831.27,399.24,833.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M714.04,241.47c1.8,1,3.8,1.8,5.6,2.8l-6.2-3.6l-0.8-0.4C713.04,240.27,713.64,240.87,714.04,241.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M376.84,821.67l4,2.4h0.2l2.4,1.6l1.2,0.6c-2-1.2-3.8-2.8-5.8-4C378.44,822.07,377.44,822.07,376.84,821.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M387.24,827.47c-0.6-0.4-1.4-0.6-2-1c-0.2,0-0.2-0.2-0.4-0.2l-1.2-0.6l1.6,1c1.8,1,2.6,2.8,2.6,4.8 c4.2,1,8.4,1.8,12.8,2.4c-0.6-0.2-1-0.6-1.6-0.8C394.84,831.27,391.04,829.67,387.24,827.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M721.24,244.67l-4.2-2.2l-3.4-2l6.2,3.6C720.24,244.27,720.44,244.27,721.24,244.67c0.4,0.2,0.6,0.6,1,0.8 l2.8,1.6c2.4,1.6,4.6,3.4,7,5.2c0.8,0.6,1.8,1.2,2.8,1.8c-2.6-3.2-5.2-6.4-8-9.2c-0.8,0.4-1.6,0.6-2.4,0.6 C723.04,245.47,722.24,245.27,721.24,244.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M340.64,792.07c0.2,0.2,0.4,0.4,0.6,0.8h0.2C341.24,792.47,341.04,792.27,340.64,792.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M352.84,807.67l24.2,14c0.6,0.2,1.4,0.4,2,0.6c-6.2-4.2-11.8-8.8-17-14.2c-0.2,0-0.4-0.2-0.4-0.2 c-0.6-0.2-1-0.6-1.4-1c-2.8,0-5.6,0-8.4-0.4C351.84,807.07,352.44,807.47,352.84,807.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M714.04,241.47c-0.4-0.4-0.8-0.8-1.4-1.2l-24.2-14c-0.6-0.2-1.2-0.2-1.8-0.4c1.6,2.2,2.8,4.6,4.2,6.8 c0.4,0.2,1,0.4,1.4,0.6C700.04,234.87,707.24,237.87,714.04,241.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M341.64,792.67h-0.2c1.6,2.4,3.4,4.6,5.2,6.8c1.2,0.2,2.4,0.4,3.8,0.4 C347.24,797.67,344.24,795.27,341.64,792.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M678.04,224.67c-2.8-0.4-5.6-0.8-8.6-1c3.6,1,7,2.2,10.4,3.4C679.24,226.47,678.84,225.47,678.04,224.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M691.04,232.67c-1.4-2.4-2.8-4.6-4.2-6.8c-2.8-0.6-5.6-0.6-8.4-1c0.6,0.8,1.2,1.6,1.8,2.4 C683.84,228.87,687.44,230.47,691.04,232.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M359.84,807.07c-3.4-2-6.8-4.4-10-7c-1.2-0.2-2.4-0.4-3.8-0.4c1.8,2.4,3.4,4.8,5.2,7 C354.24,806.67,357.24,806.67,359.84,807.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M255.64,760.87c0.6,4,1,8.2,1.8,12.2C256.64,768.67,256.24,764.87,255.64,760.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M641.24,152.67c-2,0.4-3.8,0.8-5.8,1.4C637.44,153.47,639.24,152.87,641.24,152.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M667.44,148.47c-1.8,0.2-3.4,0.4-5.2,0.6C663.84,149.07,665.64,148.87,667.44,148.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M688.84,147.87c4.8,0.2,9.4,0.6,14.2,1C698.44,148.47,693.84,147.87,688.84,147.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M391.64,333.27c-4.6,6-9.2,12.2-13.6,18.4C382.44,345.27,386.84,339.07,391.64,333.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M583.04,172.07c-2.6,1.2-5,2.4-7.6,3.6C578.04,174.27,580.44,173.27,583.04,172.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M538.84,196.07c6-3.8,12.2-7.4,18.2-10.8c-2.4,1.2-4.6,2.2-6.8,3.6C546.24,191.07,542.64,193.87,538.84,196.07 z"
}), React.createElement("path", {
  className: "st1",
  d: "M411.84,307.67c-3,3.6-6,7.4-9,11.2C406.04,314.87,409.04,311.07,411.84,307.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M475.04,243.47c-8,7-15.8,14.2-23.6,21.8C459.24,257.87,466.84,250.47,475.04,243.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M528.64,202.67c-17.4,11.4-34.4,24.6-51.2,39C493.64,227.67,510.64,214.27,528.64,202.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M610.44,160.87c-0.4,0.2-0.8,0.2-1.2,0.4C609.84,161.47,610.24,161.07,610.44,160.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M252.84,738.47c0,0.8,0,1.6,0.2,2.2C252.84,739.87,252.84,738.87,252.84,738.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M252.84,670.27c0,0.4,0,0.6,0,1C252.84,671.27,252.84,670.87,252.84,670.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M258.04,630.07c-0.4,2.8-1,5.4-1.4,8.2C257.24,635.27,257.44,632.67,258.04,630.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M266.64,589.67c-1.4,5.8-2.8,11.6-4,17.4C263.64,601.07,264.84,595.07,266.64,589.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M285.44,847.47c2,3.2,4.2,6.4,6.4,9.4C289.64,853.67,287.44,850.47,285.44,847.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M264.24,799.67c0.8,2.6,1.8,5.2,2.8,7.8C266.04,804.87,264.84,802.47,264.24,799.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.24,578.87c22.2-82.4,62.8-162.6,108.4-227.2c-13.8,19.2-26.8,39-39,60 C307.24,466.47,284.04,523.47,269.24,578.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M431.24,285.87c3.2-3.4,6.4-6.8,9.8-10.2C437.84,279.07,434.44,282.27,431.24,285.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M273.64,825.07c1.2,2.8,2.6,5.2,4,8C276.24,830.27,274.84,827.87,273.64,825.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M302.84,499.07c0.6-1.2,1-2.4,1.6-3.8C303.64,496.47,303.44,497.87,302.84,499.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.24,897.67L344.24,897.67c0-0.2-0.2-0.2-0.2-0.2c-4.4-2.6-8.6-5.8-12.8-8.8c2.6,2,5,4,7.8,5.8 c-6.6-3.8-17.8-10.2-30-17c8.6,8.6,17.8,16.4,28,22.6c0.6,0.2,1.4,0.6,2,0.6C341.04,900.87,343.04,899.87,344.24,897.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M393.64,340.87c4.8-6.2,9.6-12.4,14.4-18.4C403.04,328.27,398.44,334.27,393.64,340.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M543.84,200.27c1.8-1,3.4-2.2,5.2-3.2C547.24,198.27,545.24,199.07,543.84,200.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M418.64,309.47c-1.4,1.6-2.6,3.2-3.8,4.8c6.8-8,13.6-15.8,20.8-23.4 C429.24,297.07,423.64,303.27,418.64,309.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M444.84,280.87c3-3,6-6,9-9C450.64,274.67,447.84,277.87,444.84,280.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M280.64,560.27c-21.8,71.2-30.4,144.6-17.2,211.2c1.8,9,4.2,17.8,6.8,26.4c-8.2-26.6-12.8-57.2-12.8-91.8 C257.44,659.07,265.64,609.87,280.64,560.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M730.24,160.47c1.8,0.6,3.6,1,5.4,1.6C733.84,161.47,731.84,161.07,730.24,160.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M701.64,155.27c4,0.4,8,0.8,11.8,1.4C709.64,155.87,705.44,155.47,701.64,155.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M560.24,190.47c6.6-3.6,13.2-7.2,19.8-10.2C573.44,183.47,566.84,187.07,560.24,190.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M376.84,363.87c2.4-3.4,4.6-6.8,7-10C381.64,357.27,379.24,360.47,376.84,363.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M304.24,862.67c-3-3.8-6-7.6-8.8-11.6C298.04,855.07,301.04,858.87,304.24,862.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M756.84,170.87c-2-1-3.8-1.4-5.8-2.4c3.6,1.6,7.4,3.2,10.8,5.2c0.2,0,0.2,0.2,0.4,0.2l0,0 c1.4-2.8,0.4-5.8-1.8-7.6c-10.8-5.8-22.4-10-34.4-13.2L756.84,170.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M316.84,876.47c-2.4-2.2-4.8-4.4-7-6.8C312.24,872.27,314.44,874.27,316.84,876.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M317.44,466.07L317.44,466.07L317.44,466.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M291.64,846.07c-8.2-13-15-27.8-20.4-44.2C276.64,817.47,283.44,832.27,291.64,846.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M280.64,560.07c3.4-11.4,7.2-22.6,11.4-33.8C288.04,537.27,284.24,548.67,280.64,560.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M585.24,177.87c38-17.2,74-24.8,106.2-23.6C656.04,152.67,620.04,162.07,585.24,177.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M331.24,888.67c-5-3.6-9.8-7.8-14.4-12.2c-2.4-2.2-4.8-4.4-7-6.8c-2-2.2-4-4.6-5.8-7c-3.2-3.8-6-7.6-8.8-11.6 c-1.2-1.8-2.4-3.4-3.4-5.2c-8.6-13.6-15.2-28.4-20.4-44.2c-0.4-1.2-0.8-2.4-1.2-3.6c-2.6-8.6-5-17.4-6.8-26.4 c-13.2-66.6-4.6-140,17.2-211.2c0-0.2,0-0.4,0.2-0.4c3.4-11.4,7.2-22.6,11.4-33.8c3.2-9,7-18,10.6-27c0.6-1.2,1-2.4,1.6-3.8 c4.2-9.8,8.6-19.6,13.2-29.2l0,0c8.2-17.4,17-34.4,26.6-51.2c10.2-17.6,21.2-34.6,32.8-51c2.4-3.4,4.6-6.8,7-10 c3.2-4.4,6.4-8.8,9.8-13.2c4.8-6.4,9.6-12.4,14.4-18.4c2.2-2.8,4.4-5.4,6.6-8c1.4-1.6,2.6-3.2,3.8-4.8c5.2-6.2,11-12.4,16.8-18.8 c3.2-3.4,6.4-6.6,9.6-9.8c3-3,5.8-6,9-9c28.2-28,58.4-52.2,89.8-71.6c1.8-1,3.4-2.2,5.2-3.2c1.4-0.8,2.8-1.8,4.2-2.8 c2.4-1.4,4.8-2.4,7.2-3.8c6.6-3.6,13-7,19.8-10.2c1.8-0.8,3.6-1.8,5.4-2.6c34.6-15.8,70.6-25.2,106.2-23.6c3.4,0.2,6.8,0.6,10,1 c4,0.4,8,0.8,11.8,1.4c5.8,1,11.2,2.4,16.6,4c1.8,0.6,3.6,1,5.4,1.6c5.4,1.8,10.6,4,15.6,6.4c2,0.8,3.8,1.4,5.8,2.4l-31-17.8 c-7.4-1.8-15.2-3.2-23-4c-4.6-0.6-9.4-1-14.2-1c-7-0.2-14.2,0-21.6,0.6c-1.8,0.2-3.4,0.4-5.2,0.6c-7,0.8-13.8,1.8-21,3.4 c-2,0.4-3.8,0.8-5.8,1.4c-8.2,2-16.4,4.2-24.8,7.2c-0.4,0.2-0.8,0.2-1.2,0.4c-8.6,3-17.4,6.6-26.2,10.6c-2.6,1.2-5,2.4-7.6,3.6 c-6.2,3-12.4,6.2-18.6,9.8c-6.2,3.4-12.2,7-18.2,10.8c-3.4,2.2-6.8,4.2-10.2,6.4c-17.8,11.8-35,25-51.2,39 c-0.8,0.6-1.4,1.2-2.2,1.8c-8.2,7-16,14.4-23.6,21.8c-3.6,3.4-7,6.8-10.6,10.4c-3.2,3.4-6.6,6.8-9.8,10.2c-6.6,7-13,14.2-19.4,21.8 c-3,3.6-6,7.4-9,11.2c-3.8,4.8-7.6,9.6-11.4,14.4c-4.6,6-9.2,12-13.6,18.4c0,0.2-0.2,0.2-0.2,0.4 c-45.8,64.4-86.2,144.6-108.4,227.2c-1,3.6-2,7-2.8,10.4c-1.4,5.8-2.8,11.6-4,17.4c-1.6,7.8-3.2,15.6-4.4,23.2 c-0.4,2.8-1,5.4-1.4,8.2c-1.6,10.8-3,21.6-3.8,32.4c0,0.4,0,0.6,0,1c-1,11.8-1.4,23.4-1.4,34.8c0,11,0.6,21.6,1.4,32 c0,0.8,0,1.6,0.2,2.2c0.6,7,1.8,13.4,2.8,20.2c0.6,4,1,8.2,1.8,12.2c1.8,9.4,4,18.2,6.8,26.8c0.8,2.8,1.8,5.2,2.8,7.8 c2,6,4.2,12.2,6.8,17.8c1.2,2.8,2.6,5.2,4,8c2.4,5,5,9.8,7.8,14.4c2,3.2,4.2,6.4,6.4,9.4c5.2,7.6,11,14.4,17.2,20.8 c12.2,7,23.4,13.2,30,17C336.24,892.67,334.04,890.87,331.24,888.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M387.84,831.27c-4-1-7.8-2.2-11.6-3.6c2,1.4,3.8,2.8,5.8,4c1.8,1,3.6,1.6,5.4,2.6 C387.84,833.47,387.84,832.47,387.84,831.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M381.04,823.87l-4-2.4c-0.2,0-0.2,0-0.4,0l7,4L381.04,823.87C381.04,824.07,381.04,824.07,381.04,823.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M385.04,826.47l-1.6-1l-7-4c-6.4-2.4-12.4-5-18.2-8.4c5.6,5.6,11.6,10.4,18,14.6c3.8,1.4,7.6,2.6,11.6,3.6 C387.84,829.67,386.84,827.47,385.04,826.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M376.84,821.67l-24.2-14c0,0.2,0.2,0.2,0.4,0.4L376.84,821.67C376.64,821.47,376.64,821.47,376.84,821.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M352.84,807.87c1.6,1.8,3.6,3.4,5.4,5.2c5.8,3.4,12,6.2,18.2,8.4L352.84,807.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M725.24,240.27c-0.4-0.2-0.6-0.6-1-0.8c-0.4-0.2-0.8-0.4-1.2-0.6L725.24,240.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M717.84,236.47c3,2.6,5.8,5.4,8.6,8.4c1-0.4,1.8-1.2,2.4-2c-1.4-0.8-2.6-2-4-2.8l-2.2-1.2 C721.44,237.87,719.64,237.27,717.84,236.47z"
}), React.createElement("polygon", {
  className: "st1",
  points: "713.64,240.47 712.64,239.87 712.64,239.87  "
}), React.createElement("path", {
  className: "st1",
  d: "M696.24,228.27c6,3.4,11.4,7.4,16.6,11.8l0.8,0.4l3.4,2l4.2,2.2c1,0.6,2,0.8,3,0.8c0.8,0,1.6-0.4,2.4-0.6 c-2.8-3-5.6-5.8-8.6-8.4C711.04,232.87,703.84,230.27,696.24,228.27z"
}), React.createElement("polygon", {
  className: "st1",
  points: "712.64,239.87 712.64,239.87 688.84,226.07 688.64,225.87  "
}), React.createElement("path", {
  className: "st1",
  d: "M696.24,228.27c-2.4-0.6-4.8-1.6-7.4-2l24.2,14C707.64,235.47,701.84,231.47,696.24,228.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M296.24,841.67c-3.8-6-7.2-12.6-10.2-19.2C289.24,829.47,292.44,835.87,296.24,841.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M321.24,872.47c-2.2-2-4.2-4-6.2-6.2C317.24,868.47,319.24,870.27,321.24,872.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M308.04,858.27c-2.8-3.4-5.4-7-8-10.8C302.84,851.27,305.44,854.87,308.04,858.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M731.04,167.27c1,0.4,2,0.4,3,0.8C732.64,167.67,731.64,167.27,731.04,167.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M793.84,468.47c-1.6,8.2-3.2,16.2-5.2,24C790.44,484.27,792.24,476.47,793.84,468.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.64,770.27c1.6,8,3.6,15.6,5.8,23c-2.2-7.6-4.2-15.6-5.8-24C269.64,769.87,269.64,770.07,269.64,770.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M284.04,817.47c-2.4-5.6-4.6-11.6-6.6-17.6C279.24,806.07,281.64,811.67,284.04,817.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M556.24,820.27c0.2-0.2,0.4-0.2,0.6-0.4c-0.4,0.2-0.8,0.4-1,0.6C555.64,820.27,556.04,820.27,556.24,820.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M605.04,786.47c-0.6,0.4-1.2,0.8-1.6,1.4C603.84,787.47,604.44,787.07,605.04,786.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M801.24,395.87c0-2.6-0.2-5-0.4-7.4c0,4.6,0.2,9.4,0,14C801.04,400.27,801.24,398.27,801.24,395.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M800.64,407.07c-0.6,19-2.8,38.2-6,57C798.04,444.27,800.24,425.27,800.64,407.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.24,637.47c-6.6,41.6-7.6,83-1.2,122.2c-2.6-16.8-4.2-34.4-4.2-53.4 C263.64,683.87,265.44,661.07,269.24,637.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M727.84,234.67c-0.2-0.2-0.4-0.4-0.8-0.6c0,0,0,0.2,0.2,0.2L727.84,234.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M535.44,831.07c-2.4,1.2-4.6,2.2-7,3.2C531.04,833.27,533.04,832.27,535.44,831.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M754.24,176.47c-2.2-1.2-4.6-1.8-7-2.8c4,1.8,8,3.4,11.6,5.4c53.8,31,83.6,97.2,83.6,186 c0,90.2-30.4,192.4-85.8,288.2c-55.2,95.8-128.6,173.4-206.8,218.4c-77,44.4-149,51.8-202.8,20.8c-5-2.8-9.4-6.2-14-9.8 c3,2.4,6,4.8,9.2,6.8c2.8,1.8,3.6,5.4,1.8,8.2c53.4,30.8,127.2,26.2,208.8-20.8c81.6-47.2,155.4-128,209-220.6s86.6-197,86.6-291.4 c0-94-33-160.2-86.4-191.2C760.64,176.67,757.24,177.87,754.24,176.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M277.84,594.67c1.4-5.6,2.8-11,4.4-16.6C280.64,583.47,279.24,588.87,277.84,594.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M453.64,280.47c2.2-2.2,4.2-4.2,6.4-6.4C457.84,276.47,455.64,278.47,453.64,280.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M511.64,229.67c1.8-1.4,3.6-2.8,5.4-4.2C515.24,226.67,513.64,228.27,511.64,229.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M799.64,366.07c0.2,2.8,0.4,5.6,0.6,8.4C800.04,372.07,800.04,369.07,799.64,366.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M492.84,847.07c-5.4,1.4-10.6,2.6-15.8,3.6C482.44,849.87,487.44,848.67,492.84,847.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M461.04,853.47c1.6-0.2,3.4-0.6,5-0.8c-6.4,0.8-12.8,1.4-19,1.6C451.64,853.87,456.24,853.67,461.04,853.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M533.04,214.07c6.2-4.2,12.4-8,18.6-11.8C545.24,206.07,539.04,210.27,533.04,214.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M556.44,199.47c9.2-5.4,18.4-10.2,27.6-14.4C575.04,189.47,565.64,194.07,556.44,199.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M269.64,635.27c1.6-9.6,3.4-19.4,5.6-29C272.84,616.07,271.04,625.47,269.64,635.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M515.04,839.87c-4,1.6-8.2,3-12.2,4.4C506.64,842.87,510.64,841.27,515.04,839.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M708.44,162.07c1.2,0.2,2.4,0.2,3.6,0.4C710.64,162.27,709.64,162.27,708.44,162.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M387.84,359.07c0-0.2,0.2-0.2,0.2-0.4C387.84,358.47,387.84,358.87,387.84,359.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M585.64,184.27c9-4.2,17.8-7.8,26.6-10.8C603.64,176.47,594.44,180.27,585.64,184.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M612.84,173.27c27-9.4,53-13.8,77.2-13C664.84,159.07,638.84,164.07,612.84,173.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M401.64,340.27c3.2-4.2,6.4-8.2,9.6-12.4C408.04,332.07,404.84,335.87,401.64,340.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M423.04,313.47c-0.4,0.6-1,1.2-1.4,1.6c6-7.2,12.2-14,18.4-20.8C434.24,300.47,428.64,307.07,423.04,313.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M740.24,243.27c1.6,1.2,3.2,2.2,4.6,3.4C743.44,245.27,741.64,244.07,740.24,243.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M629.24,765.07c-1.6,1.6-3.2,3-5,4.6C626.24,768.27,627.64,766.47,629.24,765.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M379.04,837.27c14.8,8.6,31,13.8,48.4,15.8C410.44,851.07,394.24,845.87,379.04,837.27 C379.24,837.27,379.04,837.27,379.04,837.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M650.24,744.67c1-1,1.8-2,2.8-3c-3,3.2-6.2,6.4-9.2,9.6C645.64,748.67,647.84,746.67,650.24,744.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M782.64,515.07c0.4-1.4,0.8-3,1.2-4.4c-0.8,2.6-1.4,5.2-2.2,7.8C781.64,517.47,782.44,516.27,782.64,515.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M729.24,637.47c18.8-32.6,34-66.2,45.8-100c-23.6,67.8-64.8,140-117.4,198.6 C684.24,706.47,708.64,673.67,729.24,637.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M729.64,242.27l-0.2,0.2c2.2,1.4,4.2,3.2,6.2,4.6c1.8,1.4,3.8,2.6,5.4,4c26.8,22.4,41.8,54.2,48.6,89.6 c0.4,1.6,0.6,3.2,1,5c0.8,4.8,1.4,9.6,2,14.6c1.4,11.2,2.4,23,2.4,35.6c0,31.6-4.8,64.6-13.2,97.8c-1.4,5.4-2.6,10.6-4.2,15.8 c-0.4,1.2-0.6,2.6-1,3.8c-0.2,1-0.6,1.8-1,2.8c-0.4,1.6-1,3.4-1.4,4.8c-1.8,5.6-3.8,11.4-5.8,17c-11.6,32.8-26.4,65.4-44.4,96.2 c-16,27.8-34.4,54-54.2,78.4c-0.2,0.2-0.4,0.4-0.4,0.6c-2.8,3.4-5.8,6.8-8.6,10c-4.6,5.4-9.4,10.8-14.2,16c-0.4,0.4-0.6,0.6-0.8,1 c-0.6,0.6-1.2,1-1.6,1.6c-33.8,35.8-72,65.4-113.2,84.6c-1.2,0.6-2.2,1-3.4,1.6c-5.4,2.4-10.8,4.6-16.2,6.6 c-3.2,1.2-6.6,2.4-9.8,3.4c-1.6,0.6-3.2,1.2-4.8,1.8c-11.4,3.4-22.8,5.8-34.2,7c-0.6,0-1.2,0.2-1.8,0.4c-0.6,0-1.2,0-2,0 c-6.4,0.6-12.8,0.8-19.2,0.6c-0.2,0-0.4,0-0.6,0c-6-0.2-12-1-17.8-2c-2-0.4-4-0.8-6-1.4c-3.6-0.8-7.2-1.8-10.8-3 c-2.2-0.8-4.6-1.4-6.8-2.4c-3.4-1.4-6.6-3-10-4.6c0,0.2,0,0.4,0,0.4c-1.2,2-3.2,3-5.2,3c-1,0-2-0.2-3-0.8 c15,8.4,31.2,13.8,48.4,15.8c5.6,0.6,11.6,1,17.4,1c0.8,0,1.4-0.2,2.2-0.2c6.2,0,12.6-0.8,19-1.6c3.6-0.4,7.2-1,10.8-1.8 c5.2-1,10.6-2.2,15.8-3.6c3.2-0.8,6.4-1.8,9.8-2.8c4.2-1.4,8.2-2.8,12.2-4.4c4.6-1.8,9.2-3.6,13.8-5.6c2.4-1,4.6-2.2,7-3.2 c6.6-3.2,13.4-6.6,20-10.4c0.4-0.2,0.8-0.4,1-0.6c15.8-9.2,31.4-19.8,46.6-32c0.6-0.4,1.2-0.8,1.6-1.4c6.6-5.4,13-11,19.4-16.8 c1.6-1.6,3.4-3,5-4.6c4.8-4.4,9.4-9.2,14.2-14c3.2-3.2,6.2-6.2,9.2-9.6c1.6-1.8,3.2-3.8,5-5.6c52.6-58.6,93.8-130.8,117.4-198.6 c2.2-6.4,4.4-12.6,6.2-19c0.8-2.6,1.6-5.2,2.2-7.8c1.8-6.2,3.4-12.2,4.8-18.4c2-7.8,3.6-15.8,5.2-24c0.2-1.6,0.6-3,0.8-4.6 c3.4-18.8,5.4-38,6-57c0-1.4,0.2-3,0.2-4.4c0.2-4.6,0-9.4,0-14c-0.2-4.6-0.2-9.2-0.6-13.8c-0.2-2.8-0.4-5.6-0.6-8.4 c-2.6-25.8-8.2-49-17.4-69c-9.4-20.8-22-37.6-37.4-50.8c-1.2-0.6-2.8-1.6-4.4-2.6c-4-3-8-6-12.4-8.6l-0.6-0.4 C730.24,235.87,731.24,239.67,729.64,242.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M735.44,247.27c-2-1.6-4-3.2-6.2-4.6l-0.2,0.2C731.44,244.07,733.64,245.87,735.44,247.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M776.64,299.67c5.6,12.4,10,26.2,13,41.2c-7-35.4-21.8-67.2-48.6-89.6 C755.44,263.87,767.64,279.87,776.64,299.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M774.24,521.27c0.4-1.6,1-3.2,1.4-4.8c-2.2,7.4-4.6,14.6-7.2,21.8C770.44,532.47,772.64,526.67,774.24,521.27z "
}), React.createElement("path", {
  className: "st1",
  d: "M670.04,712.47c-0.2,0.2-0.4,0.4-0.4,0.6C669.64,712.87,669.84,712.67,670.04,712.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M530.64,826.47c41.2-19,79.4-48.8,113.2-84.6c-28,29.4-58.8,54.4-90.8,73 C545.44,819.07,538.04,822.87,530.64,826.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M790.44,345.87c0.8,4.6,1.4,9.6,2,14.6C792.24,355.47,791.44,350.87,790.44,345.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M387.44,834.67c3.4,1.6,6.6,3.2,10,4.6C394.04,837.67,390.64,836.27,387.44,834.67 C387.44,834.27,387.44,834.27,387.44,834.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M781.64,493.87c-1.4,5.2-2.6,10.4-4.2,15.8C779.04,504.67,780.44,499.07,781.64,493.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M660.64,723.47c-4.8,5.4-9.4,10.8-14.2,16C651.44,734.07,656.24,728.67,660.64,723.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M458.64,847.27c-6.6,0.6-13,0.8-19.2,0.6C446.04,848.27,452.24,847.67,458.64,847.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M439.04,847.67c-6.2-0.2-12-1-17.8-2C426.84,846.67,432.84,847.47,439.04,847.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M414.84,844.27c-3.6-0.8-7.2-1.8-10.8-3C407.84,842.47,411.24,843.67,414.84,844.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M496.64,840.07c1.6-0.4,3.2-1.2,4.8-1.8c-13.4,4.4-26.4,7.4-39,8.8C474.04,845.47,485.44,843.47,496.64,840.07 z"
}), React.createElement("path", {
  className: "st1",
  d: "M527.44,828.27c-5.4,2.4-10.8,4.6-16.2,6.6C516.44,832.67,521.84,830.47,527.44,828.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M340.64,792.07c-4.2-6.4-7.8-13-11.2-20.4c-11.8-26-18.4-58.4-18.4-96.2s6.6-77.8,18.4-117.4 c12.2-41.2,30.2-82.4,52.6-121s49-74.8,78.4-106c28.6-30,59.8-55.6,92.6-74.6c32.8-19,64-29.4,92.4-32.2c8-0.8,15.6-0.8,23.2-0.4 l-0.2-0.2c-9.2-2.6-18.8-4.2-28.8-4.6c-28.6,3.8-58.8,14.4-89.8,32.2c-32.6,18.8-64.2,44.2-94,75.6 c-29.8,31.4-56.4,67.4-79.4,107.2c-23,39.6-40.8,80.8-53.2,122.4s-18.6,81.6-18.6,119.2c0,36,6,67.8,17.4,94.6 C327.84,778.27,334.04,785.27,340.64,792.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M669.64,223.47c-0.4-0.2-0.8-0.2-1-0.4l0.2,0.2C669.04,223.47,669.24,223.47,669.64,223.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M336.04,795.87c0.6,1,1.4,1.8,2,2.8c0.4,0,0.6,0,1,0.2C337.84,797.47,336.84,796.67,336.04,795.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M672.64,217.87c-1,0-2.2-0.4-3.2-0.4c1.2,0.4,2.6,0.8,3.8,1.2C673.04,218.47,672.84,217.87,672.64,217.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M341.64,801.27c-1-0.8-2-2-3-2.8c-0.4,0-0.6,0-1-0.2c0.4,0.4,0.6,0.8,1,1.2L341.64,801.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M677.64,219.67l-3-1.8c-0.6,0-1.2-0.2-2-0.2c0.2,0.2,0.4,0.4,0.6,0.8 C674.84,219.07,676.24,219.07,677.64,219.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M322.44,770.07c0.6,1.4,1,2.8,1.6,4.2c2.6,6,5.8,11.4,9,16.8c2.8,0.8,5.6,1.4,8.4,1.8 c-0.2-0.2-0.4-0.4-0.6-0.8C334.04,785.27,327.84,778.27,322.44,770.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M663.44,217.27c-6,0-12,0-18.4,0.6c-1.8,0.2-3.6,0.6-5.2,0.8c10,0.4,19.6,2,28.8,4.6 C666.84,221.47,665.24,219.07,663.44,217.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.64,806.47c-0.4,0-0.6,0-1,0l2,1.2C352.44,807.47,351.84,807.07,351.64,806.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M686.04,224.67c0.2,0.4,0.4,0.8,0.6,1.2c0.6,0.2,1.2,0.2,1.8,0.4L686.04,224.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M663.44,217.27c1.8,1.8,3.4,4,5.2,6c0.4,0.2,0.8,0.2,1,0.4c3,0.2,5.8,0.6,8.6,1c-1.6-2-3.2-4.2-4.8-6.2 c-1.2-0.4-2.6-0.8-3.8-1.2C667.64,217.27,665.44,217.27,663.44,217.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M346.24,799.67c-1.8-2.2-3.6-4.4-5.2-6.8c-2.8-0.6-5.6-1.2-8.4-1.8c1,1.6,2,3.2,3,4.8c1,1,2,2,3,2.8 C341.24,798.87,344.04,799.07,346.24,799.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M686.04,224.67l-8.4-4.8c-1.4-0.4-2.8-0.8-4.2-1.2c1.6,2,3.2,4,4.8,6.2c2.8,0.4,5.8,0.4,8.4,1 C686.44,225.27,686.24,224.87,686.04,224.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M351.64,806.47c-1.8-2.2-3.4-4.8-5.2-7c-2.6-0.4-5-0.4-7.6-1c1,1,1.8,2,3,2.8l9,5.2 C351.04,806.47,351.24,806.47,351.64,806.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M730.24,160.47c-5.6-1.6-11-3-16.6-4c-3.8-0.6-7.8-1-11.8-1.4c-3.4-0.4-6.6-0.8-10-1 c-32.4-1.2-68.2,6.4-106.2,23.6c-1.8,0.8-3.6,1.6-5.4,2.6c-6.6,3-13.2,6.6-19.8,10.2c-3.8,2.2-7.8,4.2-11.6,6.4 c-1.8,1-3.4,2.2-5.2,3.2c-33,20.6-63.8,45.8-89.8,71.6c-3,3-6,6-9,9c-3.2,3.4-6.4,6.6-9.6,9.8c-7,7.6-14,15.4-20.8,23.4 c-2.2,2.6-4.4,5.4-6.6,8c-5,6-9.8,12.2-14.4,18.4c-3.2,4.4-6.6,8.6-9.8,13.2c-2.4,3.2-4.6,6.6-7,10c-21.8,31.4-42,65.8-59.4,102.2 l0,0c-4.6,9.6-9,19.4-13.2,29.2c-0.6,1.2-1,2.4-1.6,3.8c-3.8,9-7.4,17.8-10.6,27c-4.2,11.2-8,22.6-11.4,33.8c0,0.2,0,0.4-0.2,0.4 c-14.8,49.4-23.2,98.8-23.2,146c0,34.4,4.6,65.2,12.8,91.8c0.4,1.2,0.8,2.4,1.2,3.6c5.4,16.4,12.2,31.2,20.4,44.2 c1.2,1.8,2.2,3.6,3.4,5.2c2.8,4.2,5.8,8,8.8,11.6c2,2.4,3.8,4.8,5.8,7c2.2,2.4,4.6,4.6,7,6.8c4.4,4.2,9.2,8.4,14.4,12.2 c4.2,3,8.2,6.2,12.8,8.8c0,0,0.2,0,0.2,0.2c1.6-2.8,0.8-6.4-1.8-8.2c-3.2-2.2-6.2-4.6-9.2-6.8c-4.2-3.2-8.2-6.6-12-10.2 c-2.2-2-4.2-4-6.2-6.2c-2.4-2.6-4.6-5.2-7-8c-2.8-3.4-5.4-7-8-10.8c-1.2-1.8-2.6-3.6-3.8-5.6c-3.8-6-7.2-12.6-10.2-19.2 c-0.8-1.6-1.4-3.4-2.2-5c-2.4-5.6-4.6-11.6-6.6-17.6c-0.6-2.2-1.4-4.2-2-6.4c-2.2-7.4-4.2-15-5.8-23c0-0.2,0-0.6-0.2-0.8 c-0.6-3.2-1-6.6-1.4-9.8c-6.4-39.2-5.4-80.6,1.2-122.2c0.2-0.8,0.2-1.4,0.4-2.2c1.6-9.6,3.4-19.4,5.6-29c0.8-4,1.8-7.8,2.6-11.8 c1.4-5.6,2.8-11.2,4.4-16.6c14.4-53.2,37-107.4,67.2-159.8c12-20.6,24.8-40.4,38.4-59.2c0-0.2,0.2-0.2,0.2-0.4 c4.4-6.2,9-12.4,13.6-18.4c3.2-4.2,6.4-8.2,9.6-12.4c3.4-4.4,7-8.6,10.4-12.8c0.4-0.6,1-1.2,1.4-1.6c5.4-6.4,11.2-12.8,17-19 c4.4-4.6,8.8-9.2,13.2-13.6c2.2-2.2,4.2-4.2,6.4-6.4c16.8-16.4,34-31.4,51.8-44.8c1.8-1.4,3.6-2.8,5.4-4.2 c5.2-3.8,10.6-7.6,15.8-11.2c6.2-4.2,12.4-8,18.6-11.8c1.4-0.8,3-2,4.4-2.8c0.2,0,0.4-0.2,0.4-0.2c9-5.2,18.2-10,27.6-14.4 c0.6-0.2,1-0.4,1.6-0.8c8.8-4.2,17.8-7.8,26.6-10.8c0.2,0,0.4-0.2,0.6-0.2c25.8-9,51.8-14,77.2-13c6.2,0.2,12.2,1,18.2,1.8 c1.2,0.2,2.4,0.2,3.6,0.4c6.4,1,12.8,2.8,18.8,4.6c1,0.4,2,0.4,3,0.8c4.6,1.6,9,3.6,13.6,5.6c2.4,1,4.6,1.8,7,2.8 c3,1.4,6.4,0.4,8.2-2.6c-0.2,0-0.2-0.2-0.4-0.2c-3.4-2-7.2-3.4-10.8-5.2c-5.2-2.4-10.4-4.6-15.6-6.4 C733.84,161.47,731.84,161.07,730.24,160.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M407.84,322.27c2.2-2.8,4.4-5.4,6.6-8C412.44,316.67,410.04,319.67,407.84,322.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M435.44,290.47c3-3.2,6.2-6.6,9.6-9.8C441.64,284.07,438.64,287.27,435.44,290.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M383.64,353.87c3.2-4.4,6.6-8.8,9.8-13.2C390.44,344.87,386.84,349.47,383.64,353.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M751.24,168.47c-5-2.4-10.2-4.6-15.6-6.4C741.04,164.07,746.24,166.07,751.24,168.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M580.24,180.27c1.8-0.8,3.6-1.6,5.4-2.6C583.64,178.47,581.64,179.67,580.24,180.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M713.64,156.47c5.6,1,11.2,2.4,16.6,4C724.84,159.07,719.24,157.67,713.64,156.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M691.44,154.07c3.4,0.2,6.8,0.6,10,1C698.44,154.67,695.24,154.27,691.44,154.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M553.04,194.27c-1.4,0.8-2.8,1.8-4.2,2.8c3.8-2.2,7.6-4.4,11.6-6.4C557.84,192.07,555.44,192.87,553.04,194.27 z"
}), React.createElement("path", {
  className: "st1",
  d: "M453.64,271.67c26.2-25.6,56.8-50.8,89.8-71.6C512.24,219.67,482.24,243.87,453.64,271.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M344.24,414.87c-9.6,16.6-18.4,33.8-26.6,51.2c17.4-36.4,37.6-70.8,59.4-102.2 C365.44,380.27,354.24,397.27,344.24,414.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M331.24,888.67c-5.2-3.8-10-8-14.4-12.2C321.64,881.07,326.24,885.07,331.24,888.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M295.44,851.27c-1.2-1.8-2.4-3.6-3.4-5.2C292.84,847.67,294.24,849.47,295.44,851.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M309.84,869.87c-2-2.2-4-4.6-5.8-7C306.04,865.07,307.84,867.47,309.84,869.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M280.64,560.27c0-0.2,0-0.4,0.2-0.4C280.64,560.07,280.64,560.07,280.64,560.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M271.24,801.47c-0.4-1.2-0.8-2.4-1.2-3.6C270.64,799.07,271.04,800.27,271.24,801.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M292.24,526.07c3.4-9,7-18,10.6-27C299.24,507.87,295.44,517.07,292.24,526.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M304.24,495.27c4.2-9.8,8.6-19.6,13.2-29.2C312.84,475.87,308.64,485.47,304.24,495.27z"
}), React.createElement("polygon", {
  className: "st1",
  points: "379.24,837.27 379.04,837.27 379.24,837.47  "
}), React.createElement("path", {
  className: "st1",
  d: "M379.24,837.47c1,0.4,2,0.8,3,0.8c2,0,4.2-1.2,5.2-3c0-0.2,0-0.4,0-0.4c-1.8-0.8-3.6-1.6-5.4-2.6l-8.6-5 c-6.2-2.4-12.4-5-18.2-8.4c-0.4-0.2-0.8-0.6-1.2-0.8C361.64,825.07,369.84,832.07,379.24,837.47L379.24,837.47 C379.24,837.27,379.24,837.27,379.24,837.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M374.04,827.27l4,2.2l2,1.2l2.2,1.2c-2-1.2-3.8-2.8-5.8-4C375.44,827.47,374.84,827.47,374.04,827.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M382.24,832.07c1.8,1,3.6,1.8,5.4,2.6l0,0C385.64,833.67,383.64,832.87,382.24,832.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M373.64,827.07l-24.2-14c1.6,1.6,3.2,3.2,4.8,4.8c0.4,0.2,0.8,0.6,1.2,0.8 C361.04,822.07,367.44,824.67,373.64,827.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M376.24,827.67c-6.4-4.2-12.4-9.2-18-14.6c-5.8-3.4-11.4-7.4-16.6-11.8l-2.8-1.6c3.2,4.6,6.4,9,10,13l25,14.4 C374.84,827.47,375.44,827.47,376.24,827.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M350.64,806.47h-0.2l2.6,1.4c0-0.2-0.2-0.2-0.4-0.4L350.64,806.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M352.84,807.87l-2.6-1.4h0.2l-9-5.2c5.2,4.4,10.6,8.4,16.6,11.8C356.64,811.27,354.44,809.87,352.84,807.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M377.84,829.47l-4-2.2c-0.2,0-0.2,0-0.4-0.2l8.6,5l-2.2-1.2L377.84,829.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M349.04,812.47c0,0.2,0.2,0.2,0.2,0.2l24.2,14c0.2,0,0.2,0,0.4,0.2L349.04,812.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M727.44,234.07L727.44,234.07c-0.4-0.4-0.6-0.4-1-0.6L727.44,234.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M716.44,234.67l7.8,4.6c0.4,0.2,0.6,0.6,1,0.8l3.2,1.8c0.4,0.2,0.6,0.6,1,0.8l0.2-0.2c1.6-2.8,0.6-6.6-2.2-8.2 l-1-0.6c-9-5-18.6-8.6-28.4-11.4c0.4,0.2,0.8,0.4,1.2,0.6C705.24,226.47,711.04,230.27,716.44,234.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M720.04,237.07l-3.4-2l0,0l6.4,3.8c0.4,0.2,0.8,0.4,1.2,0.6l-2.2-1.2L720.04,237.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M725.24,240.27c1.4,0.8,2.6,1.8,4,2.8l0.2-0.2c-0.4-0.2-0.6-0.6-1-0.8L725.24,240.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M716.44,235.27c0.4,0.4,1,1,1.4,1.4c1.6,0.8,3.4,1.4,5,2.4L716.44,235.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M716.44,234.67c-5.4-4.4-11-8.4-17-12c-0.4-0.2-0.8-0.4-1.2-0.6c-2.2-0.6-4.4-1.4-6.6-1.8L716.44,234.67z"
}), React.createElement("polygon", {
  className: "st1",
  points: "713.64,233.47 716.44,235.27 716.44,234.87  "
}), React.createElement("path", {
  className: "st1",
  d: "M717.84,236.47c-0.4-0.4-1-1-1.4-1.4l-3-1.8l-22.6-13c-5.2-1.2-10.8-1.8-16.2-2.2l3,1.8 c6.4,2.4,12.6,5,18.4,8.4C703.84,230.27,711.04,232.87,717.84,236.47z"
}), React.createElement("polygon", {
  className: "st1",
  points: "688.84,226.07 686.04,224.67 686.04,224.67 688.64,225.87  "
}), React.createElement("path", {
  className: "st1",
  d: "M686.04,224.67l2.8,1.6c2.6,0.6,5,1.4,7.4,2c-5.8-3.4-12-6.2-18.4-8.4L686.04,224.67L686.04,224.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M720.04,237.07l2.2,1.2l2.2,1.2l-7.8-4.6l0.2,0.2L720.04,237.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M716.44,234.87l-0.2-0.2l-25-14.4h-0.2l22.6,13L716.44,234.87z"
}), React.createElement("polygon", {
  className: "st1",
  points: "691.04,220.27 691.04,220.27 713.64,233.47  "
}), React.createElement("path", {
  className: "st1",
  d: "M550.24,596.67l-9.8,16.8c-1.2,2-3.2,3-5.2,3c-1,0-1.8-0.2-2.8-0.8l-32.6,125.2c5.4-4,10.8-8.2,16-12.4 L550.24,596.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M576.44,484.07c-0.8-0.8-1.6-1.8-2.8-2c-3.2-0.8-6.6,1.2-7.4,4.4l-5,19.2l2.4,0.6L576.44,484.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M487.44,787.87c-0.8,3.4,1.2,6.6,4.4,7.4c0.4,0.2,1,0.2,1.6,0.2c2.8,0,5.2-1.8,6-4.6l11-42.6 c-5.2,3.8-10.4,7.6-15.6,11.2L487.44,787.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M513.44,738.27l2.4-9.4c-5.2,4.2-10.6,8.4-16,12.4l-2.2,8.8C502.84,746.27,508.04,742.27,513.44,738.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M497.44,750.07l-2.6,9.6c5.4-3.6,10.6-7.4,15.6-11.2l2.6-10.2C508.04,742.27,502.84,746.27,497.44,750.07z"
}), React.createElement("polygon", {
  className: "st2",
  points: "439.84,483.87 423.64,517.87 537.84,550.47 557.24,517.47  "
}), React.createElement("path", {
  className: "st1",
  d: "M414.84,521.67l21.4-45.4l123.2,35l1.6-6l-123-35c-3-0.8-6,0.6-7.2,3.2l-21.6,45.6c-0.8,1.6-0.8,3.6,0,5.2 s2.2,2.8,4,3.4l118.2,33.8l3.2-5.6L414.84,521.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M565.44,571.27c0.6,0.2,1.2,0.2,1.8,0.2c2.4,0,4.6-1.4,5.6-3.6l21.4-45.4c0.4-0.6,0-1.4,0-2.2l-29.2,50.6 L565.44,571.27z"
}), React.createElement("polygon", {
  className: "st1",
  points: "560.24,511.67 563.64,506.47 561.24,505.47 559.64,511.47  "
}), React.createElement("polygon", {
  className: "st1",
  points: "423.64,517.87 439.84,483.87 557.24,517.47 558.84,514.27 559.64,511.47 436.24,476.47 414.84,521.67  534.84,556.07 537.84,550.47  "
}), React.createElement("polygon", {
  className: "st1",
  points: "560.24,511.67 559.64,511.47 558.84,514.27  "
}), React.createElement("polygon", {
  className: "st0",
  points: "543.84,565.07 525.04,597.47 532.64,602.27 538.64,592.27 545.44,565.47  "
}), React.createElement("polygon", {
  className: "st0",
  points: "703.44,307.07 695.24,302.27 575.64,509.67 584.84,512.47  "
}), React.createElement("polygon", {
  className: "st0",
  points: "538.64,592.27 552.64,567.47 545.44,565.47  "
}), React.createElement("polygon", {
  className: "st0",
  points: "561.64,552.07 578.44,523.47 569.84,521.07  "
}), React.createElement("polygon", {
  className: "st0",
  points: "569.84,521.07 569.24,520.87 550.24,553.87 559.04,556.47 561.64,552.07  "
}), React.createElement("polygon", {
  className: "st0",
  points: "547.24,559.67 546.84,559.67 543.84,565.07 545.44,565.47  "
}), React.createElement("polygon", {
  className: "st0",
  points: "581.44,517.87 584.84,512.47 575.64,509.67 572.64,515.27  "
}), React.createElement("polygon", {
  className: "st0",
  points: "547.24,559.67 545.44,565.47 552.64,567.47 556.04,562.07  "
}), React.createElement("polygon", {
  className: "st0",
  points: "578.44,523.47 581.44,517.87 572.64,515.27 570.24,519.07 569.84,521.07  "
}), React.createElement("polygon", {
  className: "st0",
  points: "547.24,559.07 546.84,559.67 547.24,559.67  "
}), React.createElement("polygon", {
  className: "st0",
  points: "570.24,519.07 569.24,520.87 569.84,521.07  "
}), React.createElement("polygon", {
  className: "st0",
  points: "556.04,562.07 559.04,556.47 550.24,553.87 547.24,559.07 547.24,559.67  "
}), React.createElement("path", {
  className: "st1",
  d: "M577.84,489.67l-1.8,7.2l117-202.6l9,5.2c-0.6-2.6-1-5.4-1.6-8l-4.4-2.6c-3-1.6-6.6-0.6-8.4,2.2l-111.6,193.2 C577.64,485.47,578.64,487.27,577.84,489.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M516.44,600.07l21.2-36.6l-6.2-1.8l-20.4,35.2c-0.8,1.4-1,3-0.6,4.6c0.4,1.6,1.4,2.8,2.8,3.8l18.6,10.6 c0.2,0,0.2,0,0.4,0l1.6-6L516.44,600.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M590.64,514.27c1.6,0.6,2.8,1.6,3.6,3c0.4,1,0,2,0,3l111.6-193.4c-0.2-3.6-0.6-7-1-10.6L590.64,514.27z"
}), React.createElement("polygon", {
  className: "st1",
  points: "558.84,569.47 556.04,574.27 550.24,596.67 565.04,571.07  "
}), React.createElement("path", {
  className: "st1",
  d: "M716.84,307.87c0.8-1.4,1-3,0.6-4.6c-0.4-1.6-1.4-2.8-2.8-3.6c0.6,3,1.4,6,1.8,9L716.84,307.87z"
}), React.createElement("path", {
  className: "st1",
  d: "M705.64,301.47l3.4,2c-0.4-2.6-1-5.4-1.6-8l-7-4c0.6,2.6,1,5.4,1.6,8L705.64,301.47z"
}), React.createElement("path", {
  className: "st1",
  d: "M706.04,327.07l5.4-9.2c-0.4-3.4-0.6-6.8-1.2-10.2l-5.2,9C705.24,319.87,705.44,323.47,706.04,327.07z"
}), React.createElement("path", {
  className: "st1",
  d: "M711.64,304.67l-1.6,2.8c0.6,3.4,0.8,6.8,1.2,10.2l5.4-9.2c-0.4-3-1.2-6-1.8-9c0,0,0-0.2-0.2-0.2l-7-4 c0.6,2.6,1.2,5.4,1.6,8L711.64,304.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M540.24,613.67l9.8-16.8l5.8-22.4l-20.8,36l-1.2-0.6l-1.6,6c0.8,0.4,1.8,0.8,2.8,0.8 C537.44,616.67,539.24,615.47,540.24,613.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M569.64,507.87l6.6-11.4l1.8-7.2c0.6-2.2-0.4-4-1.6-5.4l-12.8,22.2L569.64,507.87z"
}), React.createElement("polygon", {
  className: "st1",
  points: "557.84,517.47 557.24,517.47 537.84,550.47 543.84,552.47 552.84,536.67  "
}), React.createElement("polygon", {
  className: "st1",
  points: "563.04,518.87 557.84,517.47 552.84,536.67  "
}), React.createElement("polygon", {
  className: "st1",
  points: "541.04,557.67 534.84,556.07 531.44,561.47 537.64,563.47  "
}), React.createElement("path", {
  className: "st1",
  d: "M590.64,514.27l-3,5.4l1,0.4l-21.4,45.4l-5.2-1.4l-3.2,5.6l6,1.8l29.2-50.6c0-1,0.4-2,0-3 C593.64,515.87,592.24,514.87,590.64,514.27z"
}), React.createElement("polygon", {
  className: "st1",
  points: "569.64,507.87 563.64,506.47 560.24,511.67 566.44,513.67  "
}), React.createElement("polygon", {
  className: "st1",
  points: "537.84,550.47 534.84,556.07 541.04,557.67 543.84,552.47  "
}), React.createElement("polygon", {
  className: "st1",
  points: "567.44,565.27 588.84,520.07 587.64,519.67 562.24,563.67  "
}), React.createElement("polygon", {
  className: "st1",
  points: "558.84,514.27 557.24,517.47 557.84,517.47  "
}), React.createElement("polygon", {
  className: "st1",
  points: "557.84,517.47 563.04,518.87 566.44,513.67 560.24,511.67 558.84,514.27  "
}), React.createElement("polygon", {
  className: "st1",
  points: "532.64,602.27 525.04,597.47 543.84,565.07 537.64,563.47 516.44,600.07 533.84,609.87 538.64,592.27  "
}), React.createElement("polygon", {
  className: "st1",
  points: "557.44,568.87 556.04,574.27 558.84,569.47  "
}), React.createElement("path", {
  className: "st1",
  d: "M575.64,509.67l119.8-207.4l7.8,4.6l-118.6,205.4l5.6,1.6c0.2,0,0.2,0.2,0.4,0.2l114.2-197.8 c-0.6-5.8-1.6-11.6-2.6-17.2l-9-5.2l-117,202.6l-3.2,12.4L575.64,509.67z"
}), React.createElement("path", {
  className: "st1",
  d: "M710.24,307.27c-0.2-1.4-0.6-2.8-0.8-4.2l-3.4-2l-3.6-2c1,5.6,2,11.4,2.6,17.2L710.24,307.27z"
}), React.createElement("path", {
  className: "st1",
  d: "M711.64,304.67l-2.4-1.4c0.2,1.4,0.6,2.8,0.8,4.2L711.64,304.67z"
}), React.createElement("polygon", {
  className: "st1",
  points: "576.24,496.47 569.64,507.87 572.84,509.07  "
}), React.createElement("polygon", {
  className: "st1",
  points: "552.64,567.47 538.64,592.27 533.84,609.87 535.24,610.47 556.04,574.27 557.44,568.87  "
}), React.createElement("polygon", {
  className: "st1",
  points: "560.44,557.07 563.84,557.87 580.04,523.67 578.44,523.47 561.64,552.07  "
}), React.createElement("polygon", {
  className: "st1",
  points: "543.84,552.47 548.64,553.67 552.84,536.67  "
}), React.createElement("polygon", {
  className: "st1",
  points: "569.24,520.87 563.04,518.87 552.84,536.67 548.64,553.67 550.24,553.87  "
}), React.createElement("polygon", {
  className: "st1",
  points: "561.64,552.07 559.04,556.47 560.44,557.07  "
}), React.createElement("polygon", {
  className: "st1",
  points: "575.64,509.67 572.84,509.07 571.44,515.07 572.64,515.27  "
}), React.createElement("path", {
  className: "st1",
  d: "M587.64,519.67l3-5.4c-0.2,0-0.2-0.2-0.4-0.2l-5.6-1.6l-3.2,5.6L587.64,519.67z"
}), React.createElement("polygon", {
  className: "st1",
  points: "546.84,559.67 541.04,557.67 537.64,563.47 543.84,565.07  "
}), React.createElement("polygon", {
  className: "st1",
  points: "558.84,562.87 557.44,568.87 558.84,569.47 562.24,563.67  "
}), React.createElement("polygon", {
  className: "st1",
  points: "556.04,562.07 552.64,567.47 557.44,568.87 558.84,562.87  "
}), React.createElement("polygon", {
  className: "st1",
  points: "571.44,515.07 572.84,509.07 569.64,507.87 566.44,513.67  "
}), React.createElement("polygon", {
  className: "st1",
  points: "578.44,523.47 580.04,523.67 563.84,557.87 560.44,557.07 558.84,562.87 562.24,563.67 587.64,519.67  581.44,517.87  "
}), React.createElement("polygon", {
  className: "st1",
  points: "547.24,559.07 548.64,553.67 543.84,552.47 541.04,557.67 546.84,559.67  "
}), React.createElement("polygon", {
  className: "st1",
  points: "572.64,515.27 571.44,515.07 570.24,519.07  "
}), React.createElement("polygon", {
  className: "st1",
  points: "548.64,553.67 547.24,559.07 550.24,553.87  "
}), React.createElement("polygon", {
  className: "st1",
  points: "570.24,519.07 571.44,515.07 566.44,513.67 563.04,518.87 569.24,520.87  "
}), React.createElement("polygon", {
  className: "st1",
  points: "559.04,556.47 556.04,562.07 558.84,562.87 560.44,557.07  "
}));

var SvgTimeIcon = function SvgTimeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTimeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Time_Icon.16f19977.svg";
export { ForwardRef as ReactComponent };